export class PosConfig {
  groupIds?: string[];
  orderStatusIds?: string[];
  defaultOrderStatusId?: string;

  showTopSales?: boolean;
  topSalesLimit?: number;

  filterByBrand?: boolean;
  filterByCategory?: boolean;
  filterBySupplier?: boolean;

  automaticallyAddToCart?: boolean;
  showProductImages?: boolean;
  useDecimalInQuantity: number = 0;
  roundCashPayment: boolean = true;

  constructor() {
    this.groupIds = [];
    this.orderStatusIds = [];
    this.defaultOrderStatusId = '';
    this.filterByBrand = false;
    this.showTopSales = true;
    this.topSalesLimit = 18;
    this.filterByCategory = true;
    this.filterBySupplier = false;
    this.automaticallyAddToCart = true;
    this.showProductImages = true;
    this.useDecimalInQuantity = 0;
  }
}
